import { render } from "./ValueAnimation.vue?vue&type=template&id=2391fc3d&bindings={}"
import script from "./ValueAnimation.vue?vue&type=script&lang=ts"
export * from "./ValueAnimation.vue?vue&type=script&lang=ts"

import "./ValueAnimation.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script